/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import info from '../Res/Icon/info.png';
import './Info.css';

const InfoPopup = ({ onClick, id, text, infoIcon = true }) => {
  return (
    <>
      {infoIcon && <div id={id} onClick={onClick} className="info-div">
        <img className="info-icon" src={info} alt="info" />
      </div>}
      <UncontrolledTooltip placement="right" target={id} delay={{ show: 2000, hide: 0 }}>
        {text}
      </UncontrolledTooltip>
    </>
  );
};

export default InfoPopup;
